export const EXTRA_INPUT_SPACE = 20;

export const EMAIL_SCHEMA_REGEXP = new RegExp(
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$/
);
